import { FunctionComponent } from "react";
import {
  applyOpacityToHexColor,
  ButtonsGroupChoiceField,
  FontIcon,
  Stack,
  Text,
  TooltipHost,
  useTheme
} from "@bps/fluent-ui";
import { SecurityRoleSetsDto } from "@libs/api/gateways/plt/plt-gateway.dtos";

interface SecurityRolesGroupChoiceFieldProps {
  roleSet: SecurityRoleSetsDto;
}
export const SecurityRolesGroupChoiceField: FunctionComponent<SecurityRolesGroupChoiceFieldProps> = ({
  roleSet
}) => {
  const theme = useTheme();
  const sortedSecRoles = Array.from(roleSet.securityRoles).sort(
    (a, b) => a.securityRoleSetPrecedence - b.securityRoleSetPrecedence
  );

  const transparentPrimary = applyOpacityToHexColor(
    theme.palette.themePrimary,
    10
  );

  return (
    <ButtonsGroupChoiceField<string>
      name={`securityRoles[${roleSet.code}]`}
      styles={() => ({
        label: {
          width: 200,
          "&[data-disabled][data-checked]": {
            background: transparentPrimary
          },
          "&[data-disabled][data-checked] *, &[data-disabled][data-checked]:hover *": {
            color: theme.palette.themePrimary
          }
        },
        root: { flexWrap: "wrap" }
      })}
      options={sortedSecRoles.map(role => ({
        key: role.code,
        text: role.name,
        disabled: role.isDisabled,
        onRenderText: (_option, value) => {
          return (
            <TooltipHost
              content={role.text}
              styles={{ root: { display: "flex", alignItems: "center" } }}
            >
              <Stack
                horizontal
                verticalAlign="center"
                horizontalAlign="center"
                tokens={{ childrenGap: 8 }}
              >
                {value === role.code && role.isDisabled && (
                  <FontIcon
                    iconName="Lock"
                    styles={{
                      root: {
                        color: theme.semanticColors.errorIcon,
                        fontSize: 16
                      }
                    }}
                  />
                )}

                {role.isEffective && (
                  <FontIcon
                    iconName="BPCheckedOut"
                    styles={{
                      root: {
                        color: theme.semanticColors.successIcon,
                        fontSize: 16
                      }
                    }}
                  />
                )}
                <Text>{role.name}</Text>
              </Stack>
            </TooltipHost>
          );
        }
      }))}
    />
  );
};
